import { PrimitiveBlueprint } from "../types";
import { AVATAR_SIZE_CLASSES } from "./sizeClasses";
import { PRIMITIVE_COLORS } from "../../constants";

const PLAYER_COLORS = {
  wood: PRIMITIVE_COLORS.stone,
  trim: PRIMITIVE_COLORS.amber,
  accent: PRIMITIVE_COLORS.lightSky,
  core: PRIMITIVE_COLORS.cyan,
  mask: PRIMITIVE_COLORS.darkSlate,
  border: PRIMITIVE_COLORS.darkSlate,
  shadow: PRIMITIVE_COLORS.black,
};

export const PLAYER_BLUEPRINT: PrimitiveBlueprint = {
  id: "player",
  designSize: AVATAR_SIZE_CLASSES.MEDIUM,
  parts: [
    {
      id: "shadow",
      type: "ellipse",
      bounds: { x: 0.14, y: 0.84, w: 0.72, h: 0.14 },
      style: { fill: PLAYER_COLORS.shadow, fillAlpha: 0.28 },
      z: 0,
    },
    {
      id: "pillar",
      type: "roundRect",
      bounds: { x: 0.18, y: 0.08, w: 0.64, h: 0.78 },
      style: {
        fill: PLAYER_COLORS.wood,
      },
      z: 1,
    },
    {
      id: "cap",
      type: "roundRect",
      bounds: { x: 0.14, y: 0.06, w: 0.72, h: 0.18 },
      style: {
        fill: PLAYER_COLORS.border,
        stroke: PLAYER_COLORS.trim,
        strokeWidth: 3,
      },
      z: 2,
    },
    {
      id: "visor",
      type: "roundRect",
      bounds: { x: 0.2, y: 0.56, w: 0.6, h: 0.2 },
      style: {
        fill: PLAYER_COLORS.mask,
        stroke: PLAYER_COLORS.trim,
        strokeWidth: 3,
      },
      z: 3,
    },
    {
      id: "band",
      type: "rect",
      bounds: { x: 0.2, y: 0.32, w: 0.6, h: 0.12 },
      style: {
        fill: PLAYER_COLORS.accent,
        stroke: PLAYER_COLORS.trim,
        strokeWidth: 2,
      },
      z: 4,
    },
    {
      id: "core",
      type: "rect",
      bounds: { x: 0.36, y: 0.3, w: 0.28, h: 0.2 },
      style: {
        fill: PLAYER_COLORS.core,
      },
      z: 5,
    },
    {
      id: "eye-left",
      type: "ellipse",
      bounds: { x: 0.32, y: 0.22, w: 0.12, h: 0.08 },
      style: {
        fill: PLAYER_COLORS.trim,
        stroke: PLAYER_COLORS.border,
        strokeWidth: 2,
      },
      z: 6,
    },
    {
      id: "eye-right",
      type: "ellipse",
      bounds: { x: 0.56, y: 0.22, w: 0.12, h: 0.08 },
      style: {
        fill: PLAYER_COLORS.trim,
        stroke: PLAYER_COLORS.border,
        strokeWidth: 2,
      },
      z: 6,
    },
    {
      id: "emblem",
      type: "triangle",
      bounds: { x: 0.42, y: 0.46, w: 0.16, h: 0.16 },
      style: {
        fill: PLAYER_COLORS.trim,
        stroke: PLAYER_COLORS.border,
        strokeWidth: 2,
      },
      z: 7,
    },
    {
      id: "chevron",
      type: "line",
      bounds: { x: 0.3, y: 0.7, w: 0.4, h: 0.04 },
      style: { stroke: PLAYER_COLORS.accent, strokeWidth: 4 },
      z: 8,
    },
  ],
};
